import BookingAssistant from "./BookingAssistant";

export default BookingAssistant;